import styled from 'styled-components';
import {
  Layout,
  Typography,
  Input,
  Card,
  Transfer,
  Button,
  Table,
  Col,
} from 'antd';

import colors from '../../styles/colors';

const { Text } = Typography;
const { Content } = Layout;

export const Wrapper = styled(Content)`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 14px 15px 27px 13px;
  div::-webkit-scrollbar {
    width: 8px;
  }
  div::-webkit-scrollbar-track {
    background: #f4f4f4;
    margin: 26px 0;
    border-radius: 20px;
  }
  div::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
`;

export const Title = styled(Text)`
  color: ${props => props.color || colors.greyText};
  font-size: ${props => props.size || 18}px;
  font-weight: ${props => (props.weight ? 'bold' : 'normal')};
  line-height: ${props => props.line || 21}px;
  > span {
    font-weight: bold;
  }
`;

export const CardContent = styled(Card)`
  height: 100%;
  .ant-card-body {
    padding: 21px 16px;
  }
`;

export const InputSearch = styled(Input)`
  border: none;
  background-color: #f2f2f2;
  height: 48px;
  margin-top: 9px;
  color: #bdbdbd;
  padding-left: 28px;
  .ant-input {
    background-color: #f2f2f2;
    margin-left: 9px;
  }
`;

export const WrapperTransfer = styled.div`
  min-height: 30%;
  .ant-checkbox-inner {
    border-radius: unset;
    border: 2px solid #24a95d;
    ::after {
      background-color: #24a95d;
    }
  }
  .ant-checkbox-checked::after {
    border: 1px solid #24a95d;
    border-color: #24a95d;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #24a95d;
    border-color: #24a95d;
  }
  .anticon.anticon-down.ant-dropdown-trigger.ant-transfer-list-header-dropdown {
    display: none;
  }
  .ant-transfer-list-header-title {
    text-align: center;
    color: #001f2a;
  }
  .ant-transfer {
    justify-content: space-between;
    align-self: center;
    width: 100%;
    height: 612px;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    color: #707070;
  }
  .ant-transfer-list-body {
    padding: 16px;
  }
  .ant-transfer-list {
    min-height: 100%;
    min-width: 45%;
    background: #fff;
    height: 100%;
    border: 1px solid #cccccc;
  }
  .ant-transfer-list-header {
    background-color: transparent;
    color: #24a95d;
  }
  li:nth-child(odd) {
    background: #f2f2f2;
  }
  .ant-transfer-list-content {
    ::-webkit-scrollbar {
      width: 8px;
    }
    ::-webkit-scrollbar-track {
      background: #fff;
      margin: 26px 0;
      border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      border-radius: 20px;
    }
  }

  .ant-select-selection-overflow-item {
    background: #e0e0e0;
  }

  .ant-transfer-list-content-item-checked {
    background: transparent;
    &:hover {
      background: #f2f2f2;
    }
  }
  .ant-transfer-list-content-item.ant-transfer-list-content-item-checked {
    &:hover {
      background: #f2f2f2;
    }
  }
  .ant-select-selection-item {
    background: #e5e5e5;
  }

  .ant-transfer-operation {
    button {
      background-color: #24a95d;
      border: none;
      width: 34px;
      height: 40px;
      border-radius: 2px;
    }
    svg {
      font-size: 18px;
    }
    .ant-btn[disabled] {
      background-color: #bdbdbd;
      border-radius: 0
    }
  }
`;

export const StyledButtonCancel = styled(Button)`
  width: 116px;
  height: 40px;
  color: #fff;
  border-radius: 0;
  background: #a61f1f !important;
  border: none;
  outline: none;
  font-weight: bold;
  margin: 0 5px;
  &:hover {
    background: #a61f1f;
    color: #fff;
    transform: scale(1.05);
  }
  &:focus {
    background: #a61f1f;
    color: #fff;
  }
`;

export const StyledButton = styled(Button)`
  width: 116px;
  height: 40px;
  color: #fff;
  border-radius: 0;
  background: #24a95d !important;
  border: none;
  outline: none;
  font-weight: bold;
  margin: 0 5px;

  &:hover {
    background: #24a95d;
    color: #fff;
    transform: scale(1.05);
  }
  &:focus {
    background: #24a95d;
    color: #fff;
  }
`;

export const TransferCustom = styled(Transfer)`
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
`;

export const WrapperTable = styled.div`
  height: 100%;
  padding: 10px;
  overflow-y: auto;
`;

export const TextCustom = styled(Text)`
  color: #707070;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  font-size: ${props => props.size || 16}px;
`;
export const StyledColRowTitle = styled(Col)`
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  padding: 11px 0;
  font-size: 12px;
  font-weight: 600;
  color: #001f2a;
  line-height: 22px;
`;

export const StyledColRow = styled(Col)`
  padding: 12px 0;
  color: #828282;
  line-height: 15px;
  font-size: 12px;
  img {
    margin: 0 5px;
  }
  .ant-select,
  .ant-select-multiple,
  .ant-select-show-arrow,
  .ant-select-show-search,
  .ant-select-selection-overflow,
  .ant-select-selector {
    background-color: #f2f2f2;
    font-size: 12px;
    line-height: 15px;
    color: #828282;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: #f2f2f2;
    border-radius: 2px;
    border: none;
    color: #828282;
  }
  .ant-select-selection-item {
    background: #e0e0e0;
    border-radius: 2px;
  }
`;

export const TableList = styled(Table)`
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    border: none;
    background-color: ${colors.branco};
    color: ${colors.greyText};
  }
  .ant-table-tbody > tr > td {
    border-bottom: none;
    font-size: 14px;
    color: #828282;
  }

  .anticon,
  .anticon-close,
  .ant-tag-close-icon {
    color: #24a95d;
  }
`;
